import React from 'react'
import InputMask from 'react-input-mask'
import { TextValidator } from 'react-material-ui-form-validator'
import { useSelector } from 'react-redux'

import { useLabel } from '../../../../hooks/useLabel'
import { getDocumentFormat } from '../../../../util/documentFormats'

const onlyDigits = value => (value || '').replace(/[^\d]/g, '')

// CPF/CNPJ do cliente no formato do país: o da prop `country` ou, sem ela, o da
// lavanderia. onChange recebe um evento com o valor já formatado
const DocumentField = ({ value, onChange, onBlur, country }) => {
  const tenantCountry = useSelector(
    state => state.auth.tenantLocale?.country?.code
  )
  const format = getDocumentFormat(country || tenantCountry)
  const label = useLabel()

  const fieldLabel = label('cpf_cnpj', 'CPF/CNPJ')
  const errorMessage = `${fieldLabel} Inválido`
  const validators = ['required', `matchRegexp:${format.pattern}`]
  const errorMessages = [errorMessage, errorMessage]

  if (!format.mask)
    return (
      <TextValidator
        value={value || ''}
        onChange={e =>
          onChange({ target: { value: format.sanitize(e.target.value) } })
        }
        onBlur={onBlur}
        validators={validators}
        errorMessages={errorMessages}
        label={fieldLabel}
        fullWidth
      />
    )

  // CNPJ colado com mais de 11 dígitos: a máscara ainda é a do CPF e cortaria o valor
  const handlePaste = e => {
    const digits = onlyDigits(e.clipboardData.getData('text'))
    if (digits.length > 11) {
      e.preventDefault()
      const cnpj = digits
        .slice(0, 14)
        .replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')
      onChange({ target: { value: cnpj } })
    }
  }

  return (
    <InputMask
      mask={format.mask(onlyDigits(value))}
      maskChar=""
      formatChars={{ 9: '[0-9]', '?': '[0-9 ]' }}
      value={value || ''}
      onChange={onChange}
      onPaste={handlePaste}
      onBlur={onBlur}
    >
      {inputProps => (
        <TextValidator
          {...inputProps}
          validators={validators}
          errorMessages={errorMessages}
          label={fieldLabel}
          fullWidth
        />
      )}
    </InputMask>
  )
}

export default DocumentField
